import { ActionType } from '../models/action-type.js';
export var AuthoringContext;
(function (AuthoringContext) {
    AuthoringContext["SUPER_ADMIN"] = "SUPER_ADMIN";
    AuthoringContext["CUSTOMER_ADMIN"] = "CUSTOMER_ADMIN";
    AuthoringContext["PLAYGROUND"] = "PLAYGROUND";
})(AuthoringContext || (AuthoringContext = {}));
const EMPTY = Object.freeze({
    allowedActionTypes: Object.freeze([]),
});
const ADMIN_ALLOWED = Object.freeze({
    // The action node is for non-transfer actions only. Transfer is served
    // by its own first-class `transfer` node (see transfer-node.ts, SUP-3147).
    // Each concrete action type gets allowlisted here when its post-call
    // dispatcher lands.
    allowedActionTypes: Object.freeze([
        ActionType.EMAIL,
        ActionType.SMS,
    ]),
});
const BY_CONTEXT = {
    [AuthoringContext.SUPER_ADMIN]: ADMIN_ALLOWED,
    [AuthoringContext.CUSTOMER_ADMIN]: ADMIN_ALLOWED,
    [AuthoringContext.PLAYGROUND]: EMPTY,
};
export function resolveGraphFrontendComponentAllowlist(context) {
    return BY_CONTEXT[context];
}
function isActionNodeCandidate(node) {
    if (typeof node !== 'object' || node === null)
        return false;
    const typed = node;
    return typed.type === 'action' && typeof typed.id === 'string';
}
export function checkActionTypeAllowlist(graph, allowlist, context) {
    const issues = [];
    const allowed = new Set(allowlist.allowedActionTypes);
    const nodes = graph.nodes;
    for (const node of nodes) {
        if (!isActionNodeCandidate(node))
            continue;
        const { actionType } = node;
        if (actionType == null)
            continue;
        if (!allowed.has(actionType)) {
            issues.push({
                code: 'action_type_not_allowed',
                message: `action type "${actionType}" is not allowed in the "${context}" context`,
                ref: node.id,
            });
        }
    }
    return issues;
}
//# sourceMappingURL=graph-frontend-component-allowlist.js.map